import { Platform } from "react-native"

export const getFCMToken = (accessToken, memberId) => {
  if (Platform.OS === "web") {
    return require("./web").getWebFCMToken(accessToken, memberId)
  } else {
    console.log("-----")
    return require("./mobile").getMobileFCMToken(accessToken, memberId)
  }
}
